const getModule = {
  state: {
    selected: false,
    url: '',
    type: '',
  },
  mutations: {
    setKaratayMahalleler(state, data) {
      if (state.type == data.type) {
        state.selected = false
        state.url = ''
        state.type = ''
      } else {
        state.selected = true
        state.url = data.url
        state.type = data.type
      }
    },
  },
  actions: {
    setKaratayMahalleler({ commit }, data) {
      commit('setKaratayMahalleler', data)
    },
  },
  getters: {},
}

export default getModule
